import { render, staticRenderFns } from "./receipt-detail-list.vue?vue&type=template&id=3c98549c"
import script from "./receipt-detail-list.vue?vue&type=script&lang=js"
export * from "./receipt-detail-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports